module.exports = __webpack_public_path__ + "img/paso3.84a6ab2f.png";